/* eslint-disable */
import createIcon from '../createIcon';

const IconCaretRightOutlined = createIcon({
  name: 'icon-caret-right-outlined',
  content: '<path fill="currentColor" d="M349.5 255.5v512l325-256z" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
});
export default IconCaretRightOutlined;
